import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { AccountHolder } from '../../app/models/AccountHolder';
import { TableDirective } from '../../directives/table-directive';
import { Card } from '../../app/models/Card';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalDirective } from 'ngx-bootstrap';
import { CouponType } from '../../app/models/CouponType';
import { NgForm } from '@angular/forms';
import { Utils } from '../../providers/paytron-backend/utils';
import { DailyCouponList } from '../../app/models/DailyCouponList';
import { CurrentAccount } from '../../app/models/CurrentAccount';
import { User } from '../../app/models/User';
import { Customer } from '../../app/models/Customer';
import { Coupon } from '../../app/models/Coupon';
import { PoS } from '../../app/models/PoS';
import { Storage } from '@ionic/storage';
import { CouponTransaction } from '../../app/models/CouponTransaction';
import { TransactionType } from '../../app/models/TransactionType';
import { Observable } from 'rxjs';
import { AlertsHolder } from '../../app/models/AlertsHolder';
import { ConfigService } from '../../providers/config/config.service';
import { TranslateService } from '@ngx-translate/core';
import { CardStatus } from '../../app/models/CardStatus';
import { RegisterActivity } from '../../app/models/RegisterActivity';

@Component({
  selector: 'page-coupons',
  templateUrl: 'coupons.html',
})
export class CouponsPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('rechargeModal')
  private rechargeModal: ModalDirective;

  @ViewChild('addDailyCouponModal')
  private addDailyCouponModal: ModalDirective;

  @ViewChild('addCouponModal')
  private addCouponModal: ModalDirective;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  @ViewChild('rechargeInput')
  rechargeInput: ElementRef;

  @ViewChild('addDailyCouponForm')
  private addDailyCouponForm: NgForm;

  @ViewChild('addCouponForm')
  private addCouponForm: NgForm;

  @ViewChild('insertCardModal')
  private insertCardModal: ModalDirective;

  private pageName: string = 'page-coupons';
  private isAuthorizedToUserRelatedPages: boolean;

  private dailyCoupons: Coupon[] = [];
  private coupons: Coupon[] = [];
  private currentCoupon = new Coupon();
  private accountHolder: AccountHolder;
  private accountHolderType = AccountHolder;
  private currentCardUuid: string;
  private currentCard = new Card();
  private currentAccount = new CurrentAccount();
  private currentTransaction = new CouponTransaction();
  private dailyCouponTypes: CouponType[] = [];
  private couponTypes: CouponType[] = [];
  private navControllerService: NavControllerService;
  private dateList = [];
  private forAll: number;
  private validity;
  private pos: PoS;
  private dailyCouponList = new DailyCouponList();
  private today = new Date();
  private alertsHolder: AlertsHolder;
  private cardReaderWebSocket: WebSocket;
  private closedActivity;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private utils: Utils,
    public storage: Storage,
    private app: App,
    private configService: ConfigService,
    private translate: TranslateService
  ) {
    this.today.setHours(0, 0, 0, 0);
    this.navControllerService = new NavControllerService(app, storage);
    this.navControllerService.isAuthorizedToUserRelatedPages().then((isAuthorized: boolean) => {
      this.isAuthorizedToUserRelatedPages = isAuthorized;
    });
    this.currentCardUuid = navParams.get('cardUuid');
    this.alertsHolder = new AlertsHolder(translate);
    this.storage.get('PoS').then((pos: PoS) => {
      this.pos = pos;
    });
    this.storage.get('registerActivity').then((activity: RegisterActivity) => {
      this.closedActivity = !activity || activity.closeDate;
    });
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.rechargeModal.onShown.subscribe(() => this.utils.focus(this.rechargeInput));
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    if (this.cardReaderWebSocket) {
      this.cardReaderWebSocket.close();
    }
  }

  ionViewDidEnter() {
    this.loadCurrentCard();
    this.loadCouponTypes();
  }

  private loadCurrentCard() {
    this.backendService.getCard(this.currentCardUuid).subscribe(
      (card: Card) => {
        this.currentCard = card;
        this.accountHolder = card.type.service ? AccountHolder['User'] : AccountHolder['Customer'];
        this.validity =
          this.utils.countDaysBetween(this.currentCard.activationDate, this.currentCard.expirationDate);
        this.dateListInit();
        this.getCoupons();
        this.backendService.getCurrentAccountByCard(card).subscribe(
          (currentAccount: CurrentAccount) => {
            this.currentAccount = currentAccount;
          },
          (err: HttpErrorResponse) => {}
        );
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadCouponTypes() {
    let daily = true;
    this.backendService.getCouponTypes().subscribe(
      (types: CouponType[]) => {
        this.dailyCouponTypes = types.filter((value) => {
          return value.daily;
        });
        this.couponTypes = types.filter((value) => {
          return !value.daily;
        });
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private getCoupons() {
    this.backendService.getCouponByCard(this.currentCard).subscribe(
      (coupons) => {
        this.coupons = coupons.filter((value) => {
          return value.type.daily == false;
        });
        this.dailyCoupons = coupons.filter((value) => {
          return value.type.daily;
        });
        this.updateCouponsType();
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private updateCouponsType() {
    this.couponTypes = this.couponTypes.filter((value) => {
      return this.coupons.some((coupon) => {
        return coupon.type.uuid == value.uuid;
      })
        ? false
        : true;
    });
  }

  private dateListInit() {
    var date = new Date(this.currentCard.activationDate);
    this.dateList = Array.from(new Array(this.validity), (value, key) => {
      value = new Date();
      value.setDate(date.getDate() + key);
      return value;
    });
  }

  onForAllChange(data) {
    if (data <= 127) {
      this.dailyCouponList.amounts.fill(data);
    }
  }

  onCouponTypeChange(event) {}

  addDailyCoupons() {
    this.dailyCouponList = new DailyCouponList();
    this.dailyCouponList.amounts = new Array(this.validity);
    this.addDailyCouponForm.resetForm();
    this.forAll = null;
    this.showAddDailyCouponModal();
  }

  addCoupon() {
    this.currentCoupon = new Coupon();
    this.addCouponForm.resetForm();
    this.showAddCouponModal();
  }

  rechargeCoupon(coupon) {
    this.currentCoupon = coupon;
    this.currentTransaction = new CouponTransaction();
    this.showRechargeModal();
  }

  submitRecharge(btnEvent: HTMLButtonElement) {
    this.submitCouponTransaction(this.currentCoupon, btnEvent, (currentAmount: number) => {
      this.currentTransaction.type = TransactionType.Recharge;
      this.currentTransaction.cardUuid = this.currentCardUuid;
      this.currentTransaction.pos = this.pos;
      this.currentTransaction.coupon = this.currentCoupon;
      this.currentTransaction.amountSnapshot = currentAmount;
      return this.backendService.addCouponRechargeTransaction(this.currentTransaction);
    });
  }

  payCoupon(coupon, btnEvent: HTMLButtonElement) {
    this.currentCoupon = coupon;
    this.currentTransaction = new CouponTransaction();
    this.submitPayment(btnEvent);
  }

  submitDischarge(btnEvent: HTMLButtonElement) {
    this.submitCouponTransaction(this.currentCoupon, btnEvent, (currentAmount: number) => {
      this.currentTransaction.type = TransactionType.Discharge;
      this.currentTransaction.cardUuid = this.currentCardUuid;
      this.currentTransaction.pos = this.pos;
      this.currentTransaction.coupon = this.currentCoupon;
      this.currentTransaction.amountSnapshot = currentAmount;
      return this.backendService.addCouponDischargeTransaction(this.currentTransaction);
    });
  }

  submitPayment(btnEvent: HTMLButtonElement) {
    this.submitCouponTransaction(this.currentCoupon, btnEvent, (currentAmount: number) => {
      this.currentTransaction.type = TransactionType.Payment;
      this.currentTransaction.cardUuid = this.currentCardUuid;
      this.currentTransaction.pos = this.pos;
      this.currentTransaction.coupon = this.currentCoupon;
      this.currentTransaction.amountSnapshot = currentAmount;
      return this.backendService.addCouponPaymentTransaction(this.currentTransaction);
    });
  }

  submitCouponTransaction(
    coupon: Coupon,
    btnEvent: HTMLButtonElement,
    createAddTransactionObservable: (currentAmount: number) => Observable<CouponTransaction>
  ) {
    let dayOfStay: number;
    if (coupon.type.daily) {
      dayOfStay = this.dailyCouponDateToDayOfStay(new Date(this.currentCard.activationDate), new Date(coupon.date));
    }
    this.resetCardReaderWebSocket(
      (webSocket: WebSocket) => {
        this.sendCardReaderHaltCommand(webSocket);
        this.showInsertCardModal(btnEvent);
      },
      (webSocket: WebSocket, json: any) => {
        switch (json.messageType) {
          case 'event':
            switch (json.message.event) {
              case 'UNPROTECTED_CARD_DETECTED':
                this.sendCardReaderHaltCommand(webSocket);
                this.alertsHolder.show('Wrong card.', 'danger');
                btnEvent.disabled = false;
                webSocket.close();
                this.closeInsertCardModal();
                break;
              case 'CARD_DETECTED':
                if (json.message.values.cardId == this.currentCard.uuid) {
                  if (coupon.type.daily) {
                    this.sendCardReaderReadValuesCommand(webSocket, [
                      'CARD_ID',
                      'DAILY_COUPON[' + coupon.type.code + ',' + dayOfStay + ']',
                    ]);
                  } else {
                    this.sendCardReaderReadValuesCommand(webSocket, ['CARD_ID', 'COUPON[' + coupon.type.code + ']']);
                  }
                } else {
                  this.sendCardReaderHaltCommand(webSocket);
                  this.alertsHolder.show('Wrong card.', 'danger');
                  btnEvent.disabled = false;
                  webSocket.close();
                  this.closeInsertCardModal();
                }
                break;
            }
            break;
          case 'command-response':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                if (json.message.values.cardId == this.currentCard.uuid) {
                  if (!coupon.type.daily && json.message.values.coupons && json.message.values.coupons.length == 1) {
                    createAddTransactionObservable(json.message.values.coupons[0].amount).subscribe(
                      (transaction) => {
                        let newAmount: number =
                          transaction.coupon.amount - coupon.amount + json.message.values.coupons[0].amount;
                        this.sendCouponCardReaderWriteValuesCommand(
                          webSocket,
                          this.currentCard,
                          transaction.coupon.type.code,
                          newAmount
                        );
                      },
                      (err: HttpErrorResponse) => {
                        let errorMessage: string = 'Server error.';
                        if (err.error && err.error.code == 'TRANSACTION_REJECTED') {
                          errorMessage = 'Transaction Rejected';
                        }
                        this.alertsHolder.show(errorMessage, 'danger');
                        btnEvent.disabled = false;
                        this.sendCardReaderHaltCommand(webSocket);
                        webSocket.close();
                        this.closeInsertCardModal();
                        this.closeRechargeModal();
                        this.closeConfirmModal();
                      }
                    );
                  } else if (
                    coupon.type.daily &&
                    json.message.values.dailyCoupons &&
                    json.message.values.dailyCoupons.length == 1
                  ) {
                    createAddTransactionObservable(
                      json.message.values.dailyCoupons[0].dailyAmounts[0].amount
                    ).subscribe(
                      (transaction) => {
                        let newAmount: number =
                          transaction.coupon.amount -
                          coupon.amount +
                          json.message.values.dailyCoupons[0].dailyAmounts[0].amount;
                        this.sendDailyCouponCardReaderWriteValuesCommand(
                          webSocket,
                          this.currentCard,
                          transaction.coupon.type.code,
                          dayOfStay,
                          newAmount
                        );
                      },
                      (err: HttpErrorResponse) => {
                        let errorMessage: string = 'Server error.';
                        if (err.error && err.error.code == 'TRANSACTION_REJECTED') {
                          errorMessage = 'Transaction Rejected';
                        }
                        this.alertsHolder.show(errorMessage, 'danger');
                        btnEvent.disabled = false;
                        this.sendCardReaderHaltCommand(webSocket);
                        webSocket.close();
                        this.closeInsertCardModal();
                        this.closeRechargeModal();
                        this.closeConfirmModal();
                      }
                    );
                  } else {
                    this.alertsHolder.show('Coupon not in card.', 'danger');
                    btnEvent.disabled = false;
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                    this.closeInsertCardModal();
                  }
                }
                break;
              case 'WRITE_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  if (json.message.request.parameters.cardStatus == 'Blocked') {
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                  } else {
                    this.getCoupons();
                    btnEvent.disabled = false;
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                    this.closeInsertCardModal();
                    this.closeRechargeModal();
                    this.closeConfirmModal();
                    this.alertsHolder.show('Card write success.', 'success');
                  }
                }
                break;
            }
            break;
          case 'command-error':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  this.alertsHolder.show('Card read error.', 'danger');
                  btnEvent.disabled = false;
                  this.sendCardReaderHaltCommand(webSocket);
                  webSocket.close();
                  this.closeInsertCardModal();
                }
                break;
              case 'WRITE_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  if (json.message.request.parameters.cardStatus == 'Blocked') {
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                  } else {
                    this.alertsHolder.show('Card write error.', 'danger');
                    this.blockCard(webSocket);
                    btnEvent.disabled = false;
                    this.closeInsertCardModal();
                    this.closeRechargeModal();
                    this.closeConfirmModal();
                  }
                }
                break;
            }
            break;
        }
      },
      (webSocket: WebSocket) => {
        btnEvent.disabled = false;
      }
    );
  }

  private dailyCouponDateToDayOfStay(cardActivationDate: Date, dailyCouponDate: Date): number {
    let dayOfStay: number;
    for (let i: number = 0; !dayOfStay && i < this.validity; i++) {
      let dummyDate: Date = new Date(cardActivationDate.getTime());
      dummyDate.setDate(dummyDate.getDate() + i);
      if (dummyDate.toDateString() == dailyCouponDate.toDateString()) {
        dayOfStay = i + 1;
      }
    }
    return dayOfStay;
  }

  submitCoupon(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.currentCoupon.cardUuid = this.currentCardUuid;
    this.currentCoupon.posUuid = this.pos.uuid;
    this.resetCardReaderWebSocket(
      (webSocket: WebSocket) => {
        this.sendCardReaderHaltCommand(webSocket);
        this.showInsertCardModal(btnEvent);
      },
      (webSocket: WebSocket, json: any) => {
        switch (json.messageType) {
          case 'event':
            switch (json.message.event) {
              case 'UNPROTECTED_CARD_DETECTED':
                this.sendCardReaderHaltCommand(webSocket);
                this.alertsHolder.show('Wrong card.', 'danger');
                btnEvent.disabled = false;
                webSocket.close();
                this.closeInsertCardModal();
                break;
              case 'CARD_DETECTED':
                if (json.message.values.cardId == this.currentCard.uuid) {
                  this.sendCardReaderReadValuesCommand(webSocket, [
                    'CARD_ID',
                    'COUPON[' + this.currentCoupon.type.code + ']',
                  ]);
                } else {
                  this.sendCardReaderHaltCommand(webSocket);
                  this.alertsHolder.show('Wrong card.', 'danger');
                  btnEvent.disabled = false;
                  webSocket.close();
                  this.closeInsertCardModal();
                }
                break;
            }
            break;
          case 'command-response':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                if (json.message.values.cardId == this.currentCard.uuid) {
                  if (!json.message.values.coupons || json.message.values.coupons.length == 0) {
                    this.backendService.saveOrUpdateCoupon(this.currentCoupon).subscribe(
                      (data) => {
                        this.sendCouponCardReaderWriteValuesCommand(
                          webSocket,
                          this.currentCard,
                          data.type.code,
                          data.amount
                        );
                      },
                      (err: HttpErrorResponse) => {
                        this.alertsHolder.show('Server error.', 'danger');
                        btnEvent.disabled = false;
                        this.sendCardReaderHaltCommand(webSocket);
                        webSocket.close();
                        this.closeInsertCardModal();
                        this.closeAddCouponModal();
                        this.closeRechargeModal();
                      }
                    );
                  } else {
                    this.alertsHolder.show('Coupon already in the card.', 'danger');
                    btnEvent.disabled = false;
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                    this.closeInsertCardModal();
                  }
                }
                break;
              case 'WRITE_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  if (json.message.request.parameters.cardStatus == 'Blocked') {
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                  } else {
                    this.getCoupons();
                    btnEvent.disabled = false;
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                    this.closeInsertCardModal();
                    this.closeAddCouponModal();
                    this.closeRechargeModal();
                    this.alertsHolder.show('Card write success.', 'success');
                  }
                }
                break;
            }
            break;
          case 'command-error':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  this.alertsHolder.show('Card read error.', 'danger');
                  btnEvent.disabled = false;
                  this.sendCardReaderHaltCommand(webSocket);
                  webSocket.close();
                  this.closeInsertCardModal();
                }
                break;
              case 'WRITE_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  if (json.message.request.parameters.cardStatus == 'Blocked') {
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                  } else {
                    this.alertsHolder.show('Card write error.', 'danger');
                    this.blockCard(webSocket);
                    btnEvent.disabled = false;
                    this.closeInsertCardModal();
                    this.closeAddCouponModal();
                    this.closeRechargeModal();
                  }
                }
                break;
            }
            break;
        }
      },
      (webSocket: WebSocket) => {
        btnEvent.disabled = false;
      }
    );
  }

  submitDailyCoupons(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.dailyCouponList.cardUuid = this.currentCardUuid;
    this.dailyCouponList.posUuid = this.pos.uuid;
    this.resetCardReaderWebSocket(
      (webSocket: WebSocket) => {
        this.sendCardReaderHaltCommand(webSocket);
        this.showInsertCardModal(btnEvent);
      },
      (webSocket: WebSocket, json: any) => {
        switch (json.messageType) {
          case 'event':
            switch (json.message.event) {
              case 'UNPROTECTED_CARD_DETECTED':
                this.sendCardReaderHaltCommand(webSocket);
                this.alertsHolder.show('Wrong card.', 'danger');
                btnEvent.disabled = false;
                webSocket.close();
                this.closeInsertCardModal();
                break;
              case 'CARD_DETECTED':
                if (json.message.values.cardId == this.currentCard.uuid) {
                  let valuesToRead: string[] = ['CARD_ID'];
                  let dailyCouponCode = this.dailyCouponList.type.code;
                  this.dailyCouponList.amounts.forEach((value: number, index: number) => {
                    let dayOfStay: number = index + 1;
                    if (value == 0 || value) {
                      valuesToRead.push('DAILY_COUPON[' + dailyCouponCode + ',' + dayOfStay + ']');
                    }
                  });
                  this.sendCardReaderReadValuesCommand(webSocket, valuesToRead);
                } else {
                  this.sendCardReaderHaltCommand(webSocket);
                  this.alertsHolder.show('Wrong card.', 'danger');
                  btnEvent.disabled = false;
                  webSocket.close();
                  this.closeInsertCardModal();
                }
                break;
            }
            break;
          case 'command-response':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                if (json.message.values.cardId == this.currentCard.uuid) {
                  let isCouponAlreadyInCard: boolean = false;
                  if (json.message.values.dailyCoupons) {
                    for (
                      let i: number = 0;
                      i < json.message.values.dailyCoupons.length && !isCouponAlreadyInCard;
                      i++
                    ) {
                      let dailyCoupon = json.message.values.dailyCoupons[i];
                      if (dailyCoupon.dailyAmounts) {
                        for (let j: number = 0; j < dailyCoupon.dailyAmounts.length && !isCouponAlreadyInCard; j++) {
                          if (dailyCoupon.dailyAmounts[j].amount != 0) {
                            isCouponAlreadyInCard = true;
                          }
                        }
                        break;
                      }
                    }
                  }
                  if (!isCouponAlreadyInCard) {
                    this.backendService.addDailyCouponList(this.dailyCouponList).subscribe(
                      (data) => {
                        this.sendDailyCouponsCardReaderWriteValuesCommand(webSocket, this.currentCard, data);
                      },
                      (err: HttpErrorResponse) => {
                        let errorMessage: string = 'Server error.';
                        if (err.error && err.error.code == 'ALREADY_EXISTS') {
                          errorMessage = 'Coupon already in the card.';
                        }
                        this.alertsHolder.show(errorMessage, 'danger');
                        btnEvent.disabled = false;
                        this.sendCardReaderHaltCommand(webSocket);
                        webSocket.close();
                        this.closeInsertCardModal();
                        this.closeAddDailyCouponModal();
                      }
                    );
                  } else {
                    this.alertsHolder.show('Coupon already in the card.', 'danger');
                    btnEvent.disabled = false;
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                    this.closeInsertCardModal();
                  }
                }
                break;
              case 'WRITE_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  if (json.message.request.parameters.cardStatus == 'Blocked') {
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                  } else {
                    this.getCoupons();
                    btnEvent.disabled = false;
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                    this.closeInsertCardModal();
                    this.closeAddDailyCouponModal();
                    this.alertsHolder.show('Card write success.', 'success');
                  }
                }
                break;
            }
            break;
          case 'command-error':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  this.alertsHolder.show('Card read error.', 'danger');
                  btnEvent.disabled = false;
                  this.sendCardReaderHaltCommand(webSocket);
                  webSocket.close();
                  this.closeInsertCardModal();
                }
                break;
              case 'WRITE_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  if (json.message.request.parameters.cardStatus == 'Blocked') {
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                  } else {
                    this.alertsHolder.show('Card write error.', 'danger');
                    this.blockCard(webSocket);
                    this.getCoupons();
                    btnEvent.disabled = false;
                    this.closeInsertCardModal();
                    this.closeAddDailyCouponModal();
                  }
                }
                break;
            }
            break;
        }
      },
      (webSocket: WebSocket) => {
        btnEvent.disabled = false;
      }
    );
  }

  private resetCardReaderWebSocket(
    onOpen: (webSocket: WebSocket) => void,
    onMessage: (webSocket: WebSocket, json: any) => void,
    onError: (webSocket: WebSocket) => void
  ): void {
    if (this.cardReaderWebSocket) {
      this.cardReaderWebSocket.close();
    }
    let webSocket: WebSocket = (this.cardReaderWebSocket = new WebSocket(
      this.configService.getCardReaderWebSocketUrl()
    ));
    webSocket.addEventListener('error', (ev: Event) => {
      if (webSocket.readyState == WebSocket.CLOSED) {
        this.alertsHolder.show('Card reader not found. Set it up and retry.', 'danger');
      } else if (webSocket.readyState == WebSocket.CONNECTING) {
        this.alertsHolder.show('Card reader still connecting. Please wait.', 'danger');
      } else {
        this.alertsHolder.show('Error while reading the card.', 'danger');
        console.error('Card reader error', ev);
      }
      onError(webSocket);
    });
    webSocket.addEventListener('message', (ev: MessageEvent) => {
      let json: any = JSON.parse(ev.data);
      onMessage(webSocket, json);
    });
    webSocket.addEventListener('open', (ev: Event) => {
      onOpen(webSocket);
    });
  }

  private sendCardReaderHaltCommand(cardReaderWebSocket: WebSocket) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'HALT',
        },
      })
    );
  }

  private sendCardReaderReadValuesCommand(cardReaderWebSocket: WebSocket, valuesToRead: string[]) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'READ_VALUES',
          parameters: {
            valuesToRead: valuesToRead,
          },
        },
      })
    );
  }

  private sendCouponCardReaderWriteValuesCommand(
    cardReaderWebSocket: WebSocket,
    card: Card,
    couponCode: number,
    couponAmount: number
  ) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'WRITE_VALUES',
          parameters: {
            cardId: card.uuid,
            coupons: [
              {
                code: couponCode,
                amount: couponAmount,
              },
            ],
          },
        },
      })
    );
  }

  private sendDailyCouponCardReaderWriteValuesCommand(
    cardReaderWebSocket: WebSocket,
    card: Card,
    couponCode: number,
    couponDayOfStay: number,
    couponAmount: number
  ) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'WRITE_VALUES',
          parameters: {
            cardId: card.uuid,
            dailyCoupons: [
              {
                code: couponCode,
                dailyAmounts: [
                  {
                    dayOfStay: couponDayOfStay,
                    amount: couponAmount,
                  },
                ],
              },
            ],
          },
        },
      })
    );
  }

  private sendDailyCouponsCardReaderWriteValuesCommand(
    cardReaderWebSocket: WebSocket,
    card: Card,
    dailyCoupons: Coupon[]
  ) {
    dailyCoupons.sort((a: Coupon, b: Coupon) => {
      let result = a.type.code - b.type.code;
      if (result == 0) {
        if (a.date < b.date) {
          result = -1;
        } else if (a.date > b.date) {
          result = 1;
        } else {
          result = 0;
        }
      }
      return result;
    });
    let dailyCouponsMessageValue: any[] = [];
    let currentCode: number;
    let dailyAmounts: any[];
    dailyCoupons.forEach((dailyCoupon: Coupon) => {
      if (dailyCoupon.type.code != currentCode) {
        if (currentCode) {
          dailyCouponsMessageValue.push({
            code: currentCode,
            dailyAmounts: dailyAmounts,
          });
        }
        dailyAmounts = [];
        currentCode = dailyCoupon.type.code;
      }
      let dayOfStay: number =
        1 +
        this.dateList.findIndex((date) => {
          return date.toDateString() == new Date(dailyCoupon.date).toDateString();
        });
      let dailyAmount: any = {
        dayOfStay: dayOfStay,
        amount: dailyCoupon.amount,
      };
      dailyAmounts.push(dailyAmount);
    });
    if (currentCode) {
      dailyCouponsMessageValue.push({
        code: currentCode,
        dailyAmounts: dailyAmounts,
      });
    }
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'WRITE_VALUES',
          parameters: {
            cardId: card.uuid,
            dailyCoupons: dailyCouponsMessageValue,
          },
        },
      })
    );
  }

  private sendBlockedCardStatusCardReaderWriteValuesCommand(cardReaderWebSocket: WebSocket, card: Card) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'WRITE_VALUES',
          parameters: {
            cardId: card.uuid,
            cardStatus: 'Blocked',
          },
        },
      })
    );
  }

  private blockCard(webSocket: WebSocket) {
    this.currentCard.status = CardStatus.Blocked;
    this.currentCard.currentAccountUuid = this.currentAccount.uuid;
    this.backendService.saveOrUpdateCard(this.currentCard).subscribe(
      (card: Card) => {
        this.currentCard = card;
        this.alertsHolder.show('The card was automatically blocked.', 'danger');
      },
      (error: any) => {
        console.error(error);
        this.alertsHolder.show('Do not use the card again. Block it manually.', 'danger');
      }
    );
    this.sendBlockedCardStatusCardReaderWriteValuesCommand(webSocket, this.currentCard);
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  showRechargeModal() {
    this.rechargeModal.show();
  }

  closeRechargeModal() {
    this.rechargeModal.hide();
  }

  showAddDailyCouponModal() {
    this.addDailyCouponModal.show();
  }

  closeAddDailyCouponModal() {
    this.addDailyCouponModal.hide();
  }

  showAddCouponModal() {
    this.addCouponModal.show();
  }

  closeAddCouponModal() {
    this.addCouponModal.hide();
  }

  showConfirmModal(coupon) {
    this.currentCoupon = coupon;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  showInsertCardModal(buttonToEnableOnCancel: HTMLButtonElement) {
    this.insertCardModal['buttonToEnableOnClose'] = buttonToEnableOnCancel;
    this.insertCardModal.show();
  }

  closeInsertCardModal() {
    if (this.insertCardModal['buttonToEnableOnClose']) {
      (<HTMLButtonElement>this.insertCardModal['buttonToEnableOnClose']).disabled = false;
    }
    delete this.insertCardModal['buttonToEnableOnClose'];
    this.insertCardModal.hide();
  }

  showAccountsOwnersPage() {
    this.navControllerService.showAccountsOwnersPage(this.accountHolder);
  }

  showCurrentAccount() {
    this.navControllerService.showCurrentAccountDetails(this.currentAccount.uuid);
  }

  showAccountsOwnerDetails() {
    this.backendService.getAccountOwnerByCard(this.currentCard).subscribe(
      (owner: Customer | User) => {
        this.navControllerService.showAccountsOwnerDetails(owner.uuid, this.accountHolder);
      },
      (err: HttpErrorResponse) => {}
    );
  }

  showCardDetails() {
    this.navControllerService.showCardDetails(this.currentCard.uuid, this.accountHolder);
  }

  cancelInsertCard() {
    this.cardReaderWebSocket.close();
    this.closeInsertCardModal();
  }

  getTitle(msg: string) {
    return this.translate.instant(msg);
  }
}



// WEBPACK FOOTER //
// ./src/pages/coupons/coupons.ts